// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"63fd099a","89":"b70474d2","254":"7d13f7ec","487":"5ad9ba22","874":"84f17c8c","960":"77e9d4c4"}[chunkId] + ".chunk.js";
};